
import { Vue, Component, Ref, Prop } from 'vue-property-decorator';
import { City } from '@/common/interface/shop';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
import { FormModel } from 'ant-design-vue';
import CarService from '@/services/car.service';

@Component
export default class MarketModal extends Vue {
  visible = false;

  @lazyInject(ShopService)
  shopService!: ShopService;

  @lazyInject(CarService)
  carService!: CarService;

  @Ref('formModel')
  formModel!: FormModel;

  @Prop()
  pCitys!: any[];

  labelCol = { span: 6 };

  wrapperCol = { span: 12 };

  type = 'add';

  form: any = {
    poi: '',
    city_code: undefined,
    address: '',
    market_name: '',
  };

  rules: any = {
    poi: [{ required: true, message: '请输入POI', trigger: 'blur' }],
    city_code: [
      { required: true, message: '请选择所在城市', trigger: 'change' },
    ],
    address: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
    market_name: [
      { required: true, message: '请输入市场名称', trigger: 'blur' },
    ],
  };

  created() {
    this.getCityList();
  }

  citys: City[] = [];

  init(type: string, data?: any) {
    console.log(type, data);
    this.citys = this.pCitys;
    this.visible = true;
    this.type = type;
    if (type === 'edit') {
      const { poi, cityCode, address, name, market_id } = data;
      this.form = {
        poi,
        city_code: cityCode ? +cityCode : '',
        address,
        market_id,
        market_name: name,
      };
    }
  }

  regionFilterOption(input: string, option: any) {
    return (
      option.componentOptions.children[0].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    );
  }
  /** 获取城市里列表 */
  async getCityList() {
    const response = (await this.shopService.getCityList()) as unknown as {
      [key: string]: {
        province: City;
        city: City[];
      };
    };
    if (response) {
      const citys = Object.values(response)
        .map((item) => item.city)
        .reduce((prev, cur) => prev.concat(cur), []);
      this.citys = citys;
    } else {
      this.citys = [];
    }
  }

  handleOk() {
    // this.visible = false;
    this.formModel.validate(async (valid) => {
      if (valid) {
        const formDate = JSON.parse(JSON.stringify(this.form));
        formDate.city_code = formDate.city_code.toString();
        if (this.type === 'add') {
          const res = await this.carService.carShopMarketAdd(formDate);
          if (res) {
            this.$message.success('操作成功');
            this.handleCancel();
            this.$emit('handleParams');
          }
        } else if (this.type === 'edit') {
          const res = await this.carService.carShopMarketEdit(formDate);
          if (res) {
            this.$message.success('操作成功');
            this.handleCancel();
            this.$emit('handleParams');
          }
        }
      } else {
        return false;
      }
    });
  }

  handleCancel() {
    this.form = {
      poi: '',
      city_code: undefined,
      address: '',
      market_name: '',
    };
    this.formModel.resetFields();
    this.visible = false;
  }

  mounted() {
    // this.getCityList();
  }
}
